import clsx from 'clsx';

import Icon from '@/components/base/Icon';

export const SelectedPostMask = ({
    className,
    selected
}: {
    className?: string;
    selected?: boolean;
}) => {
    if (!selected) {
        return null;
    }

    return (
        <div
            className={clsx('absolute inset-0 bg-black/50', className)}
            data-testid="selected-post-mask">
            <span className="absolute inset-0 flex items-center justify-center">
                <Icon icon="check" className="text-4xl text-white" />
            </span>
        </div>
    );
};
